import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkhikrapurmidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Shikrapur MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Shikrapur MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides efficient and dependable Corporate Cab Services in Shikrapur MIDC, ideal for manufacturing units, factories, logistics companies, and corporate offices operating in this industrial region. Our fleet of well-maintained sedans, SUVs, and employee-transport vehicles ensures comfortable, safe, and punctual daily commuting for staff, supervisors, executives, and visiting clients. With trained chauffeurs, GPS-enabled vehicles, and flexible rental plans, we deliver smooth shift-based transportation, dedicated corporate cars, and reliable executive travel. Whether your business requires daily pick-and-drop, client transfers, or long-term corporate mobility solutions, Pune Corporate Cars India Private Limited offers professional, high-quality cab services tailored to the needs of Shikrapur MIDC.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Shikrapur Employee Cab",
    "description": "Shikrapur Employee Cab provides safe, punctual, and well-managed daily commute services for employees working in Shikrapur MIDC and surrounding industrial zones. With AC sedans, shared cabs, and shuttle vehicles, the service efficiently supports multiple shifts and flexible pickup points. Shikrapur Employee Cab ensures reliable, comfortable, and consistent travel for the workforce."
  },
  {
    "name": "Industrial Transport Shikrapur",
    "description": "Industrial Transport Shikrapur is designed for factories, production units, warehouses, and industrial plants requiring structured workforce mobility. With GPS-enabled vehicles, trained drivers, and multi-route coverage, the service ensures seamless movement for workers across all shifts. Industrial Transport Shikrapur enhances productivity through dependable daily transportation."
  },
  {
    "name": "Company Shuttle Shikrapur",
    "description": "Company Shuttle Shikrapur offers high-capacity shuttle services using vans and minibuses for large corporate and industrial teams. Ideal for multi-shift operations and fixed-route commuting, the service ensures timely and efficient employee transport. Company Shuttle Shikrapur supports smooth daily operations with organized shuttle scheduling."
  },
  {
    "name": "Worker Pickup Drop Shikrapur",
    "description": "Worker Pickup Drop Shikrapur provides dependable pickup and drop services designed for factory workers, technicians, and support staff. With flexible routes, safe driving practices, and multi-shift support, the service guarantees punctual and smooth daily travel. Worker Pickup Drop Shikrapur is essential for maintaining consistent factory operations."
  },
  {
    "name": "Business Taxi Shikrapur MIDC",
    "description": "Business Taxi Shikrapur MIDC offers premium sedans and SUVs for supervisors, managers, and corporate visitors. Ideal for plant visits, meetings, and intercity travel, the service provides clean vehicles, AC comfort, and experienced chauffeurs. Business Taxi Shikrapur MIDC ensures a professional and comfortable travel experience."
  },
  {
    "name": "Corporate Cab Provider Shikrapur",
    "description": "Corporate Cab Provider Shikrapur delivers fully managed cab services for corporates, industries, and manufacturing units. With dedicated fleets, trained drivers, and safety-monitored routes, the service supports employee commuting, executive travel, and inter-office mobility. Corporate Cab Provider Shikrapur ensures consistent and secure transportation solutions."
  },
  {
    "name": "Affordable Cab Shikrapur",
    "description": "Affordable Cab Shikrapur offers budget-friendly travel options for small and medium companies without compromising safety or comfort. With shared cabs, scheduled routes, and flexible billing plans, the service provides cost-effective workforce mobility. Affordable Cab Shikrapur ensures reliable and economical daily transportation."
  },
  {
    "name": "Monthly Corporate Cab Shikrapur",
    "description": "Monthly Corporate Cab Shikrapur provides long-term cab rental plans with dedicated vehicles assigned to the organization. Ideal for daily commute and executive use, the service includes predictable billing, priority support, and guaranteed vehicle availability. Monthly Corporate Cab Shikrapur ensures uninterrupted and efficient mobility for businesses."
  },
  {
    "name": "Best Staff Cab Shikrapur",
    "description": "Best Staff Cab Shikrapur offers top-rated cab services with clean vehicles, punctual drivers, and safe route handling. Suitable for employees, supervisors, and administrative staff, the service guarantees comfort, reliability, and professionalism. Best Staff Cab Shikrapur is trusted by many industries for high-quality staff transport."
  },
  {
    "name": "Outstation Cab Shikrapur",
    "description": "Outstation Cab Shikrapur provides safe and comfortable long-distance travel for corporate trips, plant visits, audits, and intercity meetings. With AC sedans and SUVs driven by experienced chauffeurs, the service ensures smooth and timely outstation mobility. Outstation Cab Shikrapur supports frequent business travel needs."
  },
  {
    "name": "Sedan Cab Shikrapur",
    "description": "Sedan Cab Shikrapur offers premium AC sedans perfect for executive travel, daily office commute, and intercity journeys. With professional chauffeurs and comfortable interiors, Sedan Cab Shikrapur ensures a superior travel experience for corporate clients."
  },
  {
    "name": "SUV Cab Shikrapur",
    "description": "SUV Cab Shikrapur provides spacious and powerful SUV vehicles ideal for long-distance travel, executive mobility, and industrial visits. The service ensures AC comfort, ample legroom, and smooth travel for managers and corporate guests."
  },
  {
    "name": "Employee Mobility Shikrapur",
    "description": "Employee Mobility Shikrapur delivers structured and optimized workforce mobility solutions covering multiple shifts, routes, and industrial locations. With trained drivers and monitored travel operations, the service ensures safe and efficient staff commuting every day."
  },
  {
    "name": "Factory Cab Service Shikrapur",
    "description": "Factory Cab Service Shikrapur offers organized cab transport for factory staff, technicians, helpers, and operators. Using shuttle vans, tempo travellers, and shared cabs, the service ensures punctual and safe movement of factory workers across all shifts."
  },
  {
    "name": "Corporate Fleet Shikrapur",
    "description": "Corporate Fleet Shikrapur provides companies with a complete fleet solution including sedans, SUVs, shuttle vans, and worker transport vehicles. The service covers daily commute, executive travel, inter-factory movement, and business mobility with reliable, scalable, and fully managed transport operations."
  }
],
"tableData": [
  ["Shikrapur Employee Cab", "Industrial Transport Shikrapur"],
  ["Company Shuttle Shikrapur", "Worker Pickup Drop Shikrapur"],
  ["Business Taxi Shikrapur MIDC", "Corporate Cab Provider Shikrapur"],
  ["Affordable Cab Shikrapur", "Monthly Corporate Cab Shikrapur"],
  ["Best Staff Cab Shikrapur", "Outstation Cab Shikrapur"],
  ["Sedan Cab Shikrapur", "SUV Cab Shikrapur"],
  ["Employee Mobility Shikrapur", "Factory Cab Service Shikrapur"],
  ["Corporate Fleet Shikrapur", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Shikrapur MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Shikrapur MIDC, ideal for industries, factories, and corporate offices in the area."
  },
  {
    "WhyChooseheading": "Perfect for Industrial & Corporate Commuting",
    "WhyChoosedescription": "Our transportation solutions are designed to meet the daily travel needs of employees working in manufacturing and industrial units around Shikrapur MIDC."
  },
  {
    "WhyChooseheading": "Clean, Safe & Comfortable Fleet",
    "WhyChoosedescription": "All vehicles are sanitized regularly, well-maintained, and equipped to ensure a safe and comfortable commuting experience."
  },
  {
    "WhyChooseheading": "Cost-Effective Corporate Packages",
    "WhyChoosedescription": "We offer competitive and budget-friendly monthly corporate travel plans customized to meet organizational requirements."
  },
  {
    "WhyChooseheading": "Timely Pickup & Drop Services",
    "WhyChoosedescription": "Our operations are punctual and aligned with company shift timings to ensure employees always reach on time."
  },
  {
    "WhyChooseheading": "Experienced & Polite Drivers",
    "WhyChoosedescription": "Our drivers are well-trained, professional, and familiar with Shikrapur MIDC routes, ensuring smooth and safe travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We provide round-the-clock assistance for rescheduling, emergency cab requirements, and route adjustments."
  },
  {
    "WhyChooseheading": "Easy Booking & Quick Service",
    "WhyChoosedescription": "Booking corporate cabs for Shikrapur MIDC is fast, simple, and hassle-free with Pune Corporate Cars India Private Limited."
  }
]
























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide corporate cab services in Shikrapur MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies operating in Shikrapur MIDC.',
  },
  {
    question: 'How can companies in Shikrapur MIDC book corporate cabs?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you provide employee pickup and drop services in Shikrapur MIDC?',
    answer: 'Yes, we offer structured and timely employee pickup and drop services for industries in Shikrapur MIDC.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Shikrapur MIDC?',
    answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers to meet different corporate transportation needs.',
  },
  {
    question: 'Are monthly and yearly corporate cab contracts available for Shikrapur MIDC companies?',
    answer: 'Yes, we offer flexible monthly and annual transportation contracts tailored specifically for corporate clients.',
  },
  {
    question: 'Are your drivers familiar with Shikrapur MIDC routes?',
    answer: 'Absolutely. Our drivers have excellent knowledge of Shikrapur MIDC routes to ensure safe and on-time travel.',
  },
  {
    question: 'Do you support shift-based operations for companies in Shikrapur MIDC?',
    answer: 'Yes, we handle all shift timings including early morning, late night, and rotational shifts.',
  },
  {
    question: 'What safety and hygiene measures do you follow for corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict hygiene, safety, and compliance standards.',
  },
  {
    question: 'What payment options are available for corporate cab services in Shikrapur MIDC?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Jadhav',
    feedback: 'Pune Corporate Cars India Private Limited provides punctual and dependable cab services for our Shikrapur MIDC staff. Very professional team.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Swati Gawade',
    feedback: 'Excellent service! Clean cars, polite drivers, and always on time. Highly recommended for Shikrapur MIDC companies.',
    rating: 5,
  },
];

















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Shikrapur MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-shikrapur.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Shikrapur MIDC, Pune, offering employee cabs, industrial transport, office and factory shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Shikrapur.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-shikrapur-midc"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Shikrapur MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Shikrapur MIDC, Pune, offering employee cabs, industrial transport, office and factory shuttle services, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Shikrapur."
  />

  <meta
    name="keywords"
    content="Shikrapur Employee Cab, Industrial Transport Shikrapur, Company Shuttle Shikrapur, Worker Pickup Drop Shikrapur, Business Taxi Shikrapur MIDC, Corporate Cab Provider Shikrapur, Affordable Cab Shikrapur, Monthly Corporate Cab Shikrapur, Best Staff Cab Shikrapur, Outstation Cab Shikrapur, Sedan Cab Shikrapur, SUV Cab Shikrapur, Employee Mobility Shikrapur, Factory Cab Service Shikrapur, Corporate Fleet Shikrapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinkhikrapurmidc;